
import React from "react";
import "../styles/DetailModal.css";

export default function DetailModal({ report, onClose }) {
  if (!report) return null;

  // Only treat as compare if all compare data exists
  const isCompare =
    report.type === "compare" &&
    report.results?.random_forest &&
    report.results?.xgboost;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <h2>Scan Details</h2>

        <button
          className="modal-close"
          onClick={onClose}
        >
          ✖
        </button>

        <div className="modal-body">
          <p>
            <strong>File Name:</strong>{" "}
            {report.filename || "N/A"}
          </p>

          <p>
            <strong>Scan Type:</strong>{" "}
            {report.type || "Unknown"}
          </p>

          <p>
            <strong>Status:</strong>{" "}
            {isCompare
              ? `${report.results.random_forest.prediction} / ${report.results.xgboost.prediction}`
              : report.prediction || "Pending"}
          </p>

          {isCompare ? (
            <>
              <h4>Random Forest:</h4>

              <p>
                <strong>Prediction:</strong>{" "}
                {report.results.random_forest.prediction || "N/A"}
              </p>

              <p>
                <strong>Probability:</strong>{" "}
                {report.results.random_forest.probability != null
                  ? `${(
                      report.results.random_forest.probability * 100
                    ).toFixed(2)}%`
                  : "N/A"}
              </p>

              <h4>XGBoost:</h4>

              <p>
                <strong>Prediction:</strong>{" "}
                {report.results.xgboost.prediction || "N/A"}
              </p>

              <p>
                <strong>Probability:</strong>{" "}
                {report.results.xgboost.probability != null
                  ? `${(
                      report.results.xgboost.probability * 100
                    ).toFixed(2)}%`
                  : "N/A"}
              </p>
            </>
          ) : (
            <>
              <h4>
                Model Used:{" "}
                {report.model_used?.toUpperCase() || "N/A"}
              </h4>

              <p>
                <strong>Prediction:</strong>{" "}
                {report.prediction || "Pending"}
              </p>

              <p>
                <strong>Probability:</strong>{" "}
                {report.probability != null
                  ? `${(report.probability * 100).toFixed(2)}%`
                  : "N/A"}
              </p>
            </>
          )}

          <p>
            <strong>Scan Date:</strong>{" "}
            {report.timestamp
              ? new Date(report.timestamp).toLocaleString()
              : "N/A"}
          </p>
        </div>
      </div>
    </div>
  );
}